import { render, staticRenderFns } from "./modalLogin.vue?vue&type=template&id=87ed9834&"
import script from "./modalLogin.vue?vue&type=script&lang=js&"
export * from "./modalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports